module.exports = __webpack_public_path__ + "img/video_img_black.9cb7d9b8.svg";